<template>
  <div class="box">
    <el-form-item label="控件名称">
      <el-input v-model="editing.data.title" clearable @blur="change" @change="change"></el-input>
    </el-form-item>

    <el-form-item label="控件说明">
      <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="editing.data.placeholder"> </el-input>
    </el-form-item>
    <el-form-item label="添加选项">
      <el-form :ref="editing.data.id" :model="editing.data">
        <template v-for="(option, index) in editing.data.options">
          <div :key="option.key" class="mt">
            <el-form-item :prop="'options.' + index + '.title'" :rules="[{ required: true, message: '不能为空', trigger: 'blur' }]">
              <el-input v-model="option.title" class="input-s" clearable placeholder="选项名称"></el-input>
              <span
                ><button :disabled="editing.data.options.length <= 1" @click="minus(index)" style="border: 0; background: #fff">
                  <i circle class="el-icon-minus font-20" role="button" style="color: #fff; background: #ddd; border-radius: 50%; padding: 2px" />
                </button>
                <button @click="add(index)" style="border: 0; background: #fff; padding: 0"><i class="font-20 el-icon-plus" role="button" style="color: #fff; background: #ddd; border-radius: 50%; padding: 2px" /></button>
              </span>
            </el-form-item>
          </div>
        </template>
      </el-form>
    </el-form-item>

    <el-form-item label="其他">
      <el-checkbox v-model="editing.data.require">必填</el-checkbox>
    </el-form-item>

    <el-form-item label="控件类型">
      <div>{{ editing.name }}</div>
    </el-form-item>
  </div>
</template>
<script>
import { ssidv1 } from '@/utils/common'
export default {
  name: 'SelectorSetting',
  props: {
    editing: Object
  },
  data() {
    return {}
  },
  computed: {
    validate() {
      this.$refs[this.editing.data.id].validate(v => {
        return v
      })
    }
  },
  beforeDestroy() {
    this.check()
  },
  mounted() {
    this.check()
  },

  methods: {
    change() {
      if (!this.editing.data.title) {
        this.editing.data.title = this.editing.name
      }
    },
    minus(i) {
      this.editing.data.options.splice(i, 1)
    },
    add(i) {
      this.editing.data.options.splice(i + 1, 0, {
        key: 'option-' + ssidv1(),
        title: ''
      })
    },
    check() {
      this.$refs[this.editing.data.id].validate(v => {
        if (v) {
          this.$emit('update', { id: this.editing.data.id, value: false })
        } else {
          this.$emit('update', { id: this.editing.data.id, value: true })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.label {
  float: left;
  height: 40px;
  line-height: 40px;
}

.input-s {
  width: 320px;
}
.item {
  .rights {
    padding-left: 100px;
    text-align: left;
  }
}
.box {
  padding-top: 20px;
}
</style>
